import { ProductsOverview } from 'api/odinApi';
import { TvSubscription } from '../utils/types';

export const tvSubscriptionDetails = {
  productType: 'Tv',
  address: {
    street: 'Sixabcvej',
    streetNumber: '1',
    city: 'Aalborg',
    zipCode: '9000',
    level: '31',
    side: 'MF',
    houseLetter: '',
    apartmentNumber: null,
  },
  subscriptionId: 'MOCK_TV',
};

export const tvSubscription: TvSubscription = {
  accountNumber: 650517623,
  subscriptionId: '87837768814585B368E3A5DD6ED29CD3,SP11_012_01_TV',
  paysForAccount: true,
  product: {
    groupId: 'TV',
    productName: 'Fuldpakke',
    packageName: '',
    recurringPrice: 649,
    packageRecurringPrice: 649,
    fairUseLimit: false,
    productParameters: [],
    isCollectiveOffer: false,
    bsProfileType: 'BS2',
    isOtt: false,
  },
  address: {
    street: 'Elmehusene',
    streetNumber: '30',
    city: 'Glostrup',
    zipCode: '2600',
    level: '',
    side: '',
    houseLetter: '',
    apartmentNumber: '',
    municipalityCode: '',
    streetCode: '',
  },
  broadbandSpeed: {
    uploadMaximumSpeed: 0,
    uploadMinimumSpeed: null,
    downloadMaximumSpeed: 0,
    downloadMinimumSpeed: null,
    uploadExpectedSpeed: null,
    downloadExpectedSpeed: null,
  },
  deliveryText: '',
  youseeClassicAccess: {
    username: null,
    isLoggedIn: false,
  },
  lineType: 'Coax',
  isOfflineSubscription: false,
  encryptedRootLid: '1C7657D98086D46C2E27F5ABB07BF93C',
  hasEncryptedCpr: true,
};

export const tvSubscriptionWithMixedTv = {
  accountNumber: 639339864,
  subscriptionId: '05117D3DD29BDC205A11719D48AD062B,SP11_016_01_TV',
  phoneNumber: null,
  paysForAccount: true,
  product: {
    groupId: 'TV',
    productName: 'Grundpakke med Tv-boks',
    packageName: '',
    recurringPrice: 221.43,
    packageRecurringPrice: 221.43,
    fairUseLimit: false,
    productParameters: [
      {
        parameterCode: 'MixedTvProductName',
        parameterValue: 'Bland Selv 46',
        entries: null,
      },
      {
        parameterCode: 'MixedTvProductPrice',
        parameterValue: '450',
        entries: null,
      },
    ],
    isCollectiveOffer: false,
    bsProfileType: 'BS2',
    isOtt: false,
  },
  address: {
    street: 'Skoleholmen',
    streetNumber: '23',
    city: 'Greve',
    zipCode: '2670',
    level: '1',
    side: null,
    houseLetter: '',
    apartmentNumber: '0006',
    streetCode: '7345',
    municipalityCode: '253',
  },
  broadbandSpeed: null,
  deliveryText: 'Tv via kabel-tv-stikket (Coax)',
  youseeClassicAccess: {
    username: '639339864',
    isLoggedIn: true,
  },
  lineType: 'Coax',
  isOfflineSubscription: false,
  encryptedRootLid: 'CA5B5CB58ACB30A7C2FFACAF862E662D',
  hasEncryptedCpr: true,
};

export const getSubscriptionsResponse = {
  subscriptionId: '9546F74CBA5164E69EB99C34590E63B1,SP57_825_03_TV,Tv',
  product: { productName: 'Mock data', recurringPrice: 42 },
};

export const blandselvAccessOwner = {
  hasBlandSelv: true,
  lineType: 'Dsl',
  blandSelvInfos: [
    { productName: 'Bland Selv 10', productCode: 'AP12_060_11', subscribed: false },
    { productName: 'Bland Selv 20', productCode: 'AP12_060_12', subscribed: true },
    { productName: 'Bland Selv 36', productCode: 'AP12_060_13', subscribed: false },
    {
      productName: 'Grundpakke med Tv-boks',
      productCode: 'SP11_016_03_TV',
      subscribed: false,
    },
  ],
  hasPendingChanges: false,
  paysForDsl: true,
};

export const netflixInfo = {
  showNetflix: true,
  productCode: null,
  isNetflixThroughBlandSelv: true,
};

export const tvSubscriptionOverview: ProductsOverview = {
  basicChannels: {
    productName: 'YouSee Tv Basis og BB tlf.',
    channels: [
      { src: 'https://s.c.dk/tvlab/tvicons/prddr1_1577861136_logo_svg_dark.', alt: 'DR1 HD' },
      { src: 'https://s.c.dk/tvlab/tvicons/prddr2_1577861451_logo_svg_dark.', alt: 'DR2' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_danmark_1561386808_logo_svg_dark.svg',
        alt: 'TV2 HD',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_charlie_1561113004_logo_svg_dark.svg',
        alt: 'TV2 Charlie',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_danmark_1561386808_logo_svg_dark.svg',
        alt: 'TV2 Regioner',
      },
      { src: 'https://s.c.dk/tvlab/tvicons/tv3_1551783557_logo_svg_dark.svg', alt: 'TV3' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv3_puls_1551958806_logo_svg_dark.svg',
        alt: 'TV3 PULS',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/infokanalen_1551692227_logo_svg_dark.svg',
        alt: 'Infokanal',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/eventkanalen_1551687011_logo_svg_dark.svg',
        alt: 'Eventkanal',
      },
      { src: 'https://i.c.dk/tvicons/yousee_trailerkanal_logo_svg.svg', alt: 'Trailerkanal' },
      {
        src: 'https://i.c.dk/tvicons/fallback_when_no_data_is_available_logo_large_seapp.png',
        alt: 'RegionLokal',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/prddr-ramasjang_1577861692_logo_svg_dark.',
        alt: 'DR Ramasjang',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/disney_channel_1551267232_logo_svg_dark.svg',
        alt: 'Disney Channel',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/disney_xd_1551267927_logo_svg_dark.svg',
        alt: 'Disney XD',
      },
      { src: 'https://i.c.dk/tvicons/nickelodeon_logo_svg.svg', alt: 'Nickelodeon HD' },
      { src: 'https://i.c.dk/tvicons/cartoon_network_logo_svg.svg', alt: 'Cartoon Network' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/disney_junior_1549889173_logo_svg_dark.svg',
        alt: 'Disney Junior',
      },
      { src: 'https://i.c.dk/tvicons/cnn_logo_svg.svg', alt: 'CNN International' },
      { src: 'https://s.c.dk/tvlab/tvicons/dr3_1551683017_logo_svg_dark.svg', alt: 'DR3 HD' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/discovery_channel_1569317717_logo_svg_dark.svg',
        alt: 'dk4 HD',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/mtv_1551785559_logo_svg_dark.svg',
        alt: 'MTV Danmark',
      },
      { src: 'https://i.c.dk/tvicons/vh1_logo_svg.svg', alt: 'VH1' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_fri_1561386430_logo_svg_dark.svg',
        alt: 'TV2 Fri HD',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_charlie_1561113004_logo_svg_dark.svg',
        alt: 'National Geographic HD',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/prdfolketinget_1601879690_logo_svg_dark.svg',
        alt: 'Folketingskanal',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_norge_1551726038_logo_svg_dark.svg',
        alt: 'TV2 Norge',
      },
      { src: 'https://s.c.dk/tvlab/tvicons/svt1_1551717944_logo_svg_dark.svg', alt: 'SVT1' },
      { src: 'https://s.c.dk/tvlab/tvicons/svt2_1551718359_logo_svg_dark.svg', alt: 'SVT2' },
      { src: 'https://s.c.dk/tvlab/tvicons/tv4_1551961083_logo_svg_dark.svg', alt: 'TV4' },
      { src: 'https://s.c.dk/tvlab/tvicons/ard_1550578980_logo_svg_dark.svg', alt: 'ARD' },
      { src: 'https://s.c.dk/tvlab/tvicons/zdf_1551796723_logo_svg_dark.svg', alt: 'ZDF' },
      { src: 'https://i.c.dk/tvicons/ndr_logo_svg.svg', alt: 'NDR' },
      { src: 'https://i.c.dk/tvicons/rtl_logo_svg.svg', alt: 'RTL' },
      { src: 'https://i.c.dk/tvicons/prosieben_logo_svg.svg', alt: 'Pro7' },
      { src: 'https://i.c.dk/tvicons/dr1_syn_logo_svg_dark.svg', alt: 'DR 1 Synstolkning' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/boomerang_1551103015_logo_svg_dark.svg',
        alt: 'Boomerang',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/nat_geo_wild_hd_1548988912_logo_svg_dark.svg',
        alt: 'Nat Geo Wild',
      },
      { src: 'https://i.c.dk/tvicons/nat_geo_people_hd_logo_svg.svg', alt: 'Nat Geo People' },
    ],
  },
  mixedTvChannels: {
    productName: 'Bland Selv 20',
    channels: [
      { src: 'https://s.c.dk/tvlab/tvicons/prddr1_1577861136_logo_svg_dark.', alt: 'DR1 HD' },
      { src: 'https://s.c.dk/tvlab/tvicons/prddr2_1577861451_logo_svg_dark.', alt: 'DR2' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv_2_danmark_1561386808_logo_svg_dark.svg',
        alt: 'TV2 HD',
      },
    ],
  },
  extraTvChannels: {
    productName: null,
    channels: [
      { src: 'https://i.c.dk/tvicons/tv3plus_logo_svg.svg', alt: 'TV3+' },
      { src: 'https://i.c.dk/tvicons/tv3_sport_logo_svg_dark.svg', alt: 'TV3 Sport' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/tv3_max_1551958643_logo_svg_dark.svg',
        alt: 'TV3 MAX',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/prdv-sport-golf_1592824725_logo_svg_dark.svg',
        alt: 'V sport golf',
      },
      { src: 'https://i.c.dk/tvicons/viasat_history_logo_svg.svg', alt: 'Viasat History' },
      { src: 'https://i.c.dk/tvicons/viasat_explore_logo_svg.svg', alt: 'Viasat Explorer' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/bbc_brit_1551095937_logo_svg_dark.svg',
        alt: 'BBC Brit',
      },
      {
        src: 'https://s.c.dk/tvlab/tvicons/prdcbs-reality_1601878839_logo_svg_dark.svg',
        alt: 'CBS Reality',
      },
      { src: 'https://s.c.dk/tvlab/tvicons/h2_1566558147_logo_svg_dark.svg', alt: 'HISTORY2' },
      {
        src: 'https://s.c.dk/tvlab/tvicons/prdmtv-80s_1601876956_logo_svg_dark.svg',
        alt: 'MTV 80s',
      },
    ],
  },
  extraTvPackages: {
    productName: null,
    channels: [
      {
        src: 'https://s.c.dk/tvlab/tvicons/prdviaplay_1591699648_logo_svg.svg',
        alt: 'Viaplay',
      },
    ],
  },
};

export const communicationsMock = {
  communications: [
    {
      communicationId: 'E657EE3B-F443-5EF1-E053-A1A64A0A104B',
      customerNumber: '6420085805',
      accountNumber: '511043569',
      subscriptionId: 'OT100056',
      benefitName: 'HBO Max',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med HBO Max',
      uri: null,
      contentType: null,
      systemKey: '2302-05-17-08.19.32.220724',
    },
    {
      communicationId: 'E657EE3D-CF33-604F-E053-A1A64A0ACBD4',
      customerNumber: '6420085805',
      accountNumber: '511043569',
      subscriptionId: 'OT100056',
      benefitName: 'Disney+',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med Disney+',
      uri: null,
      contentType: null,
      systemKey: '2302-05-17-08.19.32.220724',
    },
    {
      communicationId: 'E6581290-E462-67E4-E053-A1A64A0A4BE8',
      customerNumber: '6420085805',
      accountNumber: '511043569',
      subscriptionId: 'OT100056',
      benefitName: 'Viaplay',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med Viaplay',
      uri: null,
      contentType: null,
      systemKey: '2302-05-17-08.19.32.220724',
    },
    {
      communicationId: 'E5B7E1D8-F0B4-3477-E053-A1A64A0A9BD5',
      customerNumber: '6420085805',
      accountNumber: '511043569',
      subscriptionId: 'OT100056',
      benefitName: 'Netflix',
      createdDate: '2022-08-08T00:00:00',
      communicationTitle: 'Kom i gang med Netflix',
      uri: null,
      contentType: null,
      systemKey: '2302-05-17-08.19.32.220724',
    },
    {
      communicationId: 'E6581290-E435-67E4-E053-A1A64A0A4BE8',
      customerNumber: '6071099807',
      accountNumber: '511082502',
      subscriptionId: 'OT100128',
      benefitName: 'Disney+',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med Disney+',
      uri: null,
      contentType: null,
      systemKey: '2542-06-17-13.37.42.230272',
    },
    {
      communicationId: 'E657EE3B-F418-5EF1-E053-A1A64A0A104B',
      customerNumber: '6071099807',
      accountNumber: '511082502',
      subscriptionId: 'OT100128',
      benefitName: 'HBO Max',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med HBO Max',
      uri: null,
      contentType: null,
      systemKey: '2542-06-17-13.37.42.230272',
    },
    {
      communicationId: 'E6581BC4-52A5-67DC-E053-A1A64A0ADAAF',
      customerNumber: '6071099807',
      accountNumber: '511082502',
      subscriptionId: 'OT100128',
      benefitName: 'Viaplay',
      createdDate: '2022-08-16T00:00:00',
      communicationTitle: 'Kom i gang med Viaplay',
      uri: null,
      contentType: null,
      systemKey: '2542-06-17-13.37.42.230272',
    },
  ],
};
